// src/brand/brand.js
// ── THE ENTIRE REBRAND IS THIS FILE. Change ACTIVE and drop in the new logo. ──
//
// Nothing else in the codebase may hardcode the group name, logo path, ticker or
// domain. Where the approved copy says "the Group" it stays as the literal words
// "the Group" — that is deliberately brand-neutral and survives the rename.
//
// NOTE: `SuprAI Pte Ltd` (the operating subsidiary) is a DIFFERENT string from
// brand.legalName and is hardcoded where it refers to the subsidiary — it does
// not change at rename.

const BRANDS = {
  usp: {
    key: 'usp',
    legalName: 'USP Group Limited',
    shortName: 'USP Group',
    possessive: "USP Group's",
    logo: '/brand/usp-logo.png', // full colour — light backgrounds
    logoReversed: '/brand/usp-logo-white.png', // knockout — on navy
    icon: '/brand/usp-icon.png', // favicon / avatar / app tile
    // Measured from the supplied artwork (1156 x 624). Reserving space with the
    // real ratio is what keeps the swap free of layout shift.
    logoAspect: 1.853,
    domain: 'uspgroup.com',
    ticker: null, // resolved from /api/share-info; renders <PendingContent> when absent
    coRegNo: '200409104W',
    listing: 'SGX Mainboard',
    irEmail: 'ir@uspgroup.com.sg',
    copyrightHolder: 'USP Group Limited',
    // Set only on the post-rename token set: it switches on the rebrand notice
    // in the legal pages by itself at cutover.
    formerName: null,
    // Which colour system leads on marketing surfaces.
    // 'institutional' = navy/signal/cyan. 'suprai' = indigo/AI-blue/ink.
    marketingPalette: 'institutional',
  },
  suprai: {
    key: 'suprai',
    legalName: 'SuprAI Group Ltd',
    shortName: 'SuprAI Group',
    possessive: "SuprAI Group's",
    logo: '/brand/suprai-logo-full.png',
    logoReversed: '/brand/suprai-logo-full-reversed.png',
    icon: '/brand/suprai-icon.png',
    logoAspect: 2.89,
    domain: 'suprai.com',
    ticker: null,
    coRegNo: '200409104W',
    listing: 'SGX Mainboard',
    irEmail: 'investors@suprai.com',
    copyrightHolder: 'SuprAI Group Ltd',
    formerName: 'USP Group Limited',
    marketingPalette: 'suprai',
  },
};

// ⇩⇩⇩ THE REBRAND SWITCH — change 'usp' to 'suprai' on cutover day. ⇩⇩⇩
const CONFIGURED = process.env.REACT_APP_BRAND || 'usp';
const PREVIEW_KEY = 'usp.brand-preview';

/**
 * Dry-run support. Outside production, `?brand=suprai` puts the whole site into
 * the SuprAI token set for the rest of the browser session, so every page can be
 * walked under the new brand before the cutover; `?brand=off` returns to the
 * configured brand. Production always uses REACT_APP_BRAND — a public visitor
 * cannot rebrand the site from a URL.
 */
function resolveActive() {
  if (process.env.NODE_ENV === 'production') return CONFIGURED;
  try {
    const requested = new URLSearchParams(window.location.search).get('brand');
    if (requested === 'off') {
      window.sessionStorage.removeItem(PREVIEW_KEY);
      return CONFIGURED;
    }
    if (requested && BRANDS[requested]) {
      window.sessionStorage.setItem(PREVIEW_KEY, requested);
      return requested;
    }
    const stored = window.sessionStorage.getItem(PREVIEW_KEY);
    if (stored && BRANDS[stored]) return stored;
  } catch (error) {
    // no window / storage blocked — fall through to the configured brand
  }
  return CONFIGURED;
}

const ACTIVE = resolveActive();

export const brand = BRANDS[ACTIVE] || BRANDS.usp;
export const BRAND_KEYS = Object.keys(BRANDS);
export const getBrand = (key) => BRANDS[key] || BRANDS.usp;
export const configuredBrand = BRANDS[CONFIGURED] || BRANDS.usp;
export const isBrandPreview = ACTIVE !== CONFIGURED;
export default brand;
